class sideScroll {
	parent: JQuery;
	elementHeight: number;
	parentHeight: number;

	constructor(public element: JQuery) {
		this.parent = this.element.parent();
		this.anim();
	}

	anim() {
		this.elementHeight = $(this.element).outerHeight(true);
		this.parentHeight = $(this.element).parent().outerHeight(true);
		let offset = this.parentHeight / 2;
		let tl = new TimelineMax()
			.to(this.element, 0, {opacity: 1, ease:Linear.easeNone})
			.to(this.element, 0.1, { top: offset, ease:Linear.easeNone});


		new ScrollMagic.Scene({
			triggerElement: this.parent[0],
			triggerHook: 0.8,
			duration: this.parentHeight - (this.elementHeight / 2),
			reverse: true
		})
			.setTween(tl)
			.addTo(Global.controller);
	};
}
